import { render } from "./MilanFixtures.vue?vue&type=template&id=3bc0bc1e"
import script from "./MilanFixtures.vue?vue&type=script&lang=js"
export * from "./MilanFixtures.vue?vue&type=script&lang=js"

import "./MilanFixtures.vue?vue&type=style&index=0&id=3bc0bc1e&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__